export const isPackageRestrictionEnabled = () => window.SCHA.user.restrictedPackages;
